import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from './cn';

type InputProps = InputHTMLAttributes<HTMLInputElement>;

const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ className, ...props }, ref) {
  return (
    <input
      ref={ref}
      className={cn(
        'w-full rounded-lg border border-theme-border-strong bg-surface px-3 py-2.5 text-sm text-foreground',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/40 focus-visible:border-brand',
        'disabled:cursor-not-allowed disabled:opacity-50 min-h-[44px]',
        className
      )}
      {...props}
    />
  );
});

export default Input;
